<template>
<v-container theme="light">
<v-row class="contentRow">
<v-col>
<h1>Dashboard</h1>
</v-col>
<p style="margin: 30px 50px;">
				This dashboard provides an integrated view of your sustainability
				performance and that of your connections across key areas: Human Rights,
				Labour, Environment, and Anti-Corruption which aligns with the UNGC
				principles for sustainable business practices. Additionally, represents
				your company's timely risk matrix, an overview of risk definitions
				you've given, and action plans you have created, enabling comprehensive
				risk management. <br />
</p>
<DashboardRiskScore />
 
			<!-- <h1>Risk Description</h1> -->
<RiskmatrixwithtableVue />
<ActionPlanRisk :title="this.title" />
<div class="dashdivcontainer">
<div class="commenttext">
<h2>Comments:</h2>
<textarea class="commentclass" v-model="comment"></textarea>
</div>
<div class="savebutton">
<v-btn color="primary" @click="saveAsPdf">
<h2>Save as PDF</h2>
</v-btn>
</div>
</div>
</v-row>
</v-container>
</template>
 
<script>
import DashboardRiskScore from "../components/DashboardRiskScore.vue"
import ActionPlanRisk from "../components/PDF/ActionPlanRisk.vue"
import RiskmatrixwithtableVue from "../components/PDF/Riskmatrixwithtable.vue"
 
export default {
	components: {
		DashboardRiskScore,
		ActionPlanRisk,
		RiskmatrixwithtableVue,
	},
	data() {
		return {
			comment: "",
			title: "",
			matrixId: "",
		}
	},
	methods: {
		saveAsPdf() {
			const matrixId = this.$store.getters.selectedId
			if (!matrixId) {
				alert("Please select a risk matrix before saving as PDF.")
				return
			}
			this.$router.push({
				name: "DashboardPDF",
				query: {
					title: this.$store.getters.selectedTitle || "",
					matrixId: String(matrixId),
					comment: this.comment,
				},
			})
		},
	},
	watch: {
		comment(newComment) {
			sessionStorage.setItem("comment", newComment)
			this.title = this.$store.getters.selectedTitle
			this.matrixId = this.$store.getters.selectedTitle
		},
	},
	mounted() {
		this.title = this.$store.getters.selectedTitle
		this.matrixId = this.$store.getters.selectedId
	},
}
</script>
 
<style>
.selfassementcard {
	margin: 10px;
	width: 100%;
}
 
.savebutton {
	margin-top: 20px;
	margin-bottom: 20px;
	display: flex;
	justify-content: center;
}
 
.commenttext {
	display: flex;
	justify-content: center;
	flex-direction: column;
	margin: 20px;
	/* Added margin for better spacing */
}
 
.commentclass {
	width: 100%;
	height: 120px !important;
	padding: 12px 20px;
	box-sizing: border-box;
	border: 2px solid #666666;
	border-radius: 4px;
	background-color: #f8f8f8;
	font-size: 16px;
	resize: none;
}
 
.dashdivcontainer {
	width: 100%;
}
</style>